import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction, Slice } from '@reduxjs/toolkit';

export interface StatisticsState {
  selectedPayers: string[] | [];
  details: {
    selectedLabel1: string | null;
    selectedLabel2: string | null;
  };
}

export const initialState: StatisticsState = {
  selectedPayers: [],
  details: {
    selectedLabel1: null,
    selectedLabel2: null,
  },
};

const statisticsSlice: Slice<StatisticsState> = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setSelectedPayers: (state, action: PayloadAction<string[]>) => {
      state.selectedPayers = action.payload;
    },
    setSelectedLabel1: (state, action: PayloadAction<string | null>) => {
      state.details.selectedLabel1 = action.payload;
    },
    setSelectedLabel2: (state, action: PayloadAction<string | null>) => {
      state.details.selectedLabel2 = action.payload;
    },
  },
});

export const { setSelectedPayers, setSelectedLabel1, setSelectedLabel2 } =
  statisticsSlice.actions;

export default statisticsSlice.reducer;
